<template>
  <div class="intro-y box p-5">
    <!-- Name field:start -->
    <div class="mt-6" v-if="showName">
      <label :for="`form-name-${kActive}`" class="form-label">
        {{ $t(`${viewRoot}.form.name.label`) }}
      </label>

      <div class="input-group">
        <textarea
          :id="`form-name-${kActive}`"
          class="form-control w-full bg-theme-32"
          :class="localData.validations.name && 'border border-theme-6'"
          :placeholder="$t(`${viewRoot}.form.name.placeholder`)"
          v-model="localData.langs[kActive].name"
          :disabled="readOnly"
        ></textarea>
      </div>

      <div v-if="localData.validations.name" class="text-theme-6 mt-2">
        {{ localData.validations.name }}
      </div>
    </div>
    <!-- Name field:end -->
  </div>
</template>

<script>
import { ensureShape } from "@/utils/modules/nutrihub/supplements/problems.js";

export default {
  name: "SupplementProblemsModule",
  props: {
    modelValue: { type: Object, required: true },
    langs: { type: Array, required: true },
    activeLangKey: { type: String, default: "" },
    readOnly: { type: Boolean, default: false },
    // PROPS VISIBLE FIELDS
    showName: { type: Boolean, default: true },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      viewRoot: "views.supplements_problems",
      localData: ensureShape(this.modelValue, this.langs),
      syncingModel: false,
    };
  },
  computed: {
    kActive() {
      return this.activeLangKey || (localStorage.lang ? localStorage.lang : navigator.language.split("-")[0]);
    },
  },
  watch: {
    modelValue: {
      deep: true,
      handler(val) {
        if (this.syncingModel) return;
        const next = ensureShape(val, this.langs);
        if (JSON.stringify(next) !== JSON.stringify(this.localData)) {
          this.localData = next;
        }
      },
    },
    localData: {
      deep: true,
      handler(val) {
        this.syncingModel = true;
        this.$emit("update:modelValue", JSON.parse(JSON.stringify(val)));
        this.$nextTick(() => {
          this.syncingModel = false;
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.dark .form-check-switch:checked {
  background-color: rgba(41, 49, 69, 1);
  border-color: rgba(63, 72, 101, 1);

  &::before {
    background-color: #c4e8fd;
  }
}

.disabled__row {
  opacity: 0.5 !important;
}

.text-nowrap-mode {
  white-space: nowrap;
}

.min__with {
  min-width: 33%;
}
</style>
